import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../components/ui/accordion";
import { Badge } from "../../../../components/ui/badge";

export const Frame1ByAnima = (): JSX.Element => {
  // FAQ data for mapping
  const faqItems = [
    {
      question: "What`s included in the Little Monsters Travel Kit?",
      answer:
        "Each kit contains activity sheets, puzzles, coloring materials, magnetic games, storytelling cards, and a few surprise elements—all designed to keep kids engaged for hours.",
    },
    {
      question: "How is the Sky Joy™ Kit different from the Jai Pavan™ Kit?",
      answer:
        "Sky Joy™ is air travel-friendly with compact, tray table-sized activities, while Jai Pavan™ is tailored for train journeys with extended, Indian-railway-inspired activities.",
    },
    {
      question: "Is the Little Monsters kit eco-friendly?",
      answer:
        "Absolutely! Our kits are made with sustainably sourced materials, and the packaging is fully recyclable to reduce environmental impact.",
    },
    {
      question: "Can I share my child's experience with the kit?",
      answer:
        "Yes! Simply scan the QR code in your kit to upload photos of your child's artwork or share a fun review. We'd love to see how your little explorer uses the kit!",
    },
    {
      question: "Can these kits be used for both solo and group play?",
      answer:
        "Yes! The activities are great for both individual fun and group play with friends or family.",
    },
    {
      question: "What if my child doesn`t enjoy the kit?",
      answer:
        "If your child isn`t happy, contact us within 30 days for a full refund or exchange.",
    },
  ];

  return (
    <section id="faqs" className="flex flex-col items-center justify-center w-full min-h-screen p-16">
      <div className="flex flex-col items-center justify-center gap-8 w-full max-w-4xl">
        <Badge
          variant="outline"
          className="px-4 py-2 rounded-[100px] border-[#169c79] opacity-[0.93]"
        >
          <span className="font-extrabold text-[#169c79] text-xs leading-[16.8px]">
            FAQ&apos;s
          </span>
        </Badge>

        <div className="flex flex-col items-center justify-center gap-4 w-full pb-4">
          <h2 className="font-bold text-[#1a1a1a] text-[40px] leading-[60px] [font-family:'Plus_Jakarta_Sans',Helvetica]">
            Frequently Asked Questions
          </h2>

          <p className="text-[#595959] text-base text-center leading-6 [font-family:'Plus_Jakarta_Sans',Helvetica]">
            Everything you need to know before purchasing a Little Monsters
            Travel Kit for your energetic explorer.
          </p>
        </div>
      </div>

      <Accordion type="single" collapsible className="w-full max-w-3xl">
        {faqItems.map((item, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="mb-6 bg-neutral-50 rounded-xl overflow-hidden border border-solid border-[#e8e8e8]"
          >
            <AccordionTrigger className="px-4 py-4 hover:no-underline">
              <span className="font-medium text-black text-base leading-6 [font-family:'Plus_Jakarta_Sans',Helvetica]">
                {item.question}
              </span>
            </AccordionTrigger>
            <AccordionContent className="px-4 pb-4">
              <p className="font-normal text-black text-base leading-6 [font-family:'Plus_Jakarta_Sans',Helvetica]">
                {item.answer}
              </p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
